import React from 'react';
import { CustomModal } from '../../../../components';
import { GoodsRequest } from '../../types/goods-response';
import GoodsDetailView from '../Views/WarehouseDetailView';
import { useDownloadFilesGoods, useDownloadPDFGoods, useFetchGoodsById } from '../../../../hooks';


interface GoodsDetailProps {
  isOpen: boolean;
  OnClose: () => void;
  isLoading?: boolean;
  id?: string;
}

const GoodsDetailContainer: React.FC<GoodsDetailProps> = ({
  isOpen,
  OnClose,
  isLoading,
  id,
}) => {

  const { mutateAsync } = useDownloadFilesGoods();
  const { mutateAsync: downloadPDF } = useDownloadPDFGoods();
  const [footerLeft, setFooterLeft] = React.useState<React.ReactNode>(null);

  const { data: detailData, isPending: isLoadingData, refetch: refetchId } =
    useFetchGoodsById(id);
  
  const closeAndReset = () => {
    OnClose()
  }
 
  return (
    <CustomModal
      title={`Detalle solicitud de bienes - ${detailData?.ticket || '-'}`}
      open={isOpen}
      onCancel={closeAndReset}
      width="95vw"
      isLoading={isLoading}
      footerLeft={footerLeft}
      labelCancel={'Finalizar'}
    >
      {!isLoadingData && <GoodsDetailView
        setFooterLeft={setFooterLeft}
        onDocuments={mutateAsync}
        onDownloadPDF={downloadPDF}
        detailData={detailData}
      />}
    </CustomModal>
  );
};

export default GoodsDetailContainer;
